import { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  TextField,
  List,
  ListItem,
  ListItemText,
  Avatar,
  Typography,
} from "@material-ui/core";

const AssigneeSelector = ({ agents, currentAssignee, onAssign }) => {
  const [search, setSearch] = useState("");

  const filtered = agents.filter((agent) =>
    agent.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box>
      <TextField
        size="small"
        placeholder="Search agents..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        fullWidth
        variant="outlined"
        autoFocus
      />
      <List dense sx={{ maxHeight: 240, overflow: "auto", mt: 1 }}>
        {filtered.map((agent) => (
          <ListItem
            key={agent.id}
            button
            onClick={() => onAssign(agent)}
            selected={currentAssignee === agent.id}
            sx={{ borderRadius: 1 }}
          >
            <Avatar
              sx={{
                width: 28,
                height: 28,
                fontSize: 11,
                fontWeight: 500,
                backgroundColor: "#5A9559",
                color: "#fff",
                mr: 1,
              }}
            >
              {agent.name
                .split(" ")
                .map((n) => n[0])
                .join("")
                .toUpperCase()
                .slice(0, 2)}
            </Avatar>
            <ListItemText primary={agent.name} secondary={agent.email} />
          </ListItem>
        ))}
        {filtered.length === 0 && (
          <ListItem>
            <Typography variant="body2" sx={{ color: "text.secondary", fontStyle: "italic" }}>
              No agents found
            </Typography>
          </ListItem>
        )}
      </List>
    </Box>
  );
};

AssigneeSelector.propTypes = {
  agents: PropTypes.array.isRequired,
  currentAssignee: PropTypes.string,
  onAssign: PropTypes.func.isRequired,
};

export default AssigneeSelector;
